<template>
  <div class="switch">
    <div class="onoffswitch">
      <input
        type="checkbox"
        :checked="value === true || value === 'checked'"
        class="onoffswitch-checkbox"
        :id="id"
        @change="triggerChange"
        v-model="val"
      >
      <label class="onoffswitch-label" :for="id">
        <span class="onoffswitch-inner" :data-label-on="labelOn || 'ON'" :data-label-off="labelOff || 'OFF'"></span>
        <span class="onoffswitch-switch"></span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      val: false
    }
  },
  props: ['id', 'value', 'labelOn', 'labelOff'],
  methods: {
    triggerChange () {
      this.$emit('input', this.val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Form/OnOff.vue